<template>
  <div>
    <el-dialog title="生成电子面单" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">

      <!-- 弹窗内容 -->
      <el-table :data="tableData" style="width: 100%" border size="mini">
        <el-table-column prop="documents" label="销售单"></el-table-column>
        <el-table-column prop="truename" label="收件人"></el-table-column>
        <el-table-column prop="phone" label="联系方式"></el-table-column>
        <el-table-column prop="address_detail" label="收件人地址">
          <template slot-scope="scope">
            {{ scope.row.address_detail }}
            <el-button type="text" @click="copyText(`${scope.row.truename}，${scope.row.phone}，${scope.row.address_detail}`)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column label="订单备注">
          <template slot-scope="scope">
            {{ scope.row.note }}
            <el-button type="text" @click="copyText(scope.row.note)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- 修改收货地址 -->
            <el-button type="text" @click="changeAddresss(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>



      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" size="mini">
        <el-form-item label="选择快递：">
          <el-select v-model="searchForm.selectedCourier" placeholder="请选择快递">
            <!-- 这里的数据待定 -->
            <el-option v-for="item in courierCompanyList" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建方式：">
          <el-select v-model="searchForm.creationMethod" placeholder="请选择创建方式">
            <el-option label="按整托生成电子面单" value="1"></el-option>
            <el-option label="按分拣箱生成电子面单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="searchForm.creationMethod == 1" label="生成记录数量：">
          <el-input-number v-model="searchForm.generate_waybill_num" size="mini" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="generateExpress" :loading="createLoading">生成电子面单</el-button>
          <el-button type="primary" @click="getExpressBacth" :disabled="isPrintDisabled"
            :loading="createLoading">批量获取面单</el-button>
        </el-form-item>
      </el-form>

      <!-- 分割线 -->
      <!-- <div class="divider"></div> -->

      <!-- 新增的el-table列表 -->
      <el-table :data="tableList" ref="expressRef" @selection-change="selectionLineChangeHandle" style="width: 100%"
        border size="mini">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="box_value" label="序号/箱号" width="100"></el-table-column>
        <el-table-column v-if="searchForm.creationMethod == 2" prop="num" label="商品数量"></el-table-column>
        <!-- <el-table-column prop="weight" label="商品重量(kg)"></el-table-column> -->
        <el-table-column label="快递信息">
          <template slot-scope="scope">
            {{ !scope.row.logistics_code ? '暂无快递单' : `${scope.row.logistics_name} | ${scope.row.logistics_code}` }}
          </template>
        </el-table-column>
        <el-table-column label="快递打印状态">
          <template slot-scope="scope">
            {{ scope.row.is_print == 0 ? '未打印' : '已打印' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="warning" @click="recycleExpress(scope.row)" v-if="scope.row.recycle_status == 1"
              size="mini">回收面单</el-button>
            <el-button type="primary" @click="getExpress(scope.row)" v-else size="mini">获取面单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="printExpress" :disabled="isPrintDisabled">打印</el-button>
      </span>
    </el-dialog>

    <!-- 修改收货地址 -->
    <el-dialog title="修改收货地址" :visible.sync="changAddressDialog" width="500px" @close="resetForm">
      <p>智能识别地址</p>
      <el-input type="textarea" v-model="addressText" placeholder="请输入地址"></el-input>
      <div style="display: flex; justify-content: flex-end;margin-bottom: 20px;margin-top: 10px;">
        <el-button type="primary" @click="parseAddress" size="mini" :disabled="!addressText">解析</el-button>
      </div>

      <el-form :model="form" :rules="rules" ref="changeAddRef" label-width="100px">
        <el-form-item label="收件人" prop="truename">
          <el-input v-model="form.truename"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="省份" prop="province_id">
          <el-select v-model="form.province_id" placeholder="请选择" style="width: 100%;" @change="changeprovince">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市" prop="city_id">
          <el-select v-model="form.city_id" placeholder="请选择" style="width: 100%;" @change="changeCity">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区/县" prop="county_id">
          <el-select v-model="form.county_id" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changAddressDialog = false">保 存</el-button>
        <el-button type="primary" @click="submitForm('changeAddRef')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import md5 from '@/assets/md5/md52.js'
import Base64 from '@/assets/md5/base64.js'

export default {
  computed: {
    isPrintDisabled() {
      return this.expressSelection.length === 0;
    },
    tableList() {
      if (this.searchForm.creationMethod == 1) {
        // 整托生成的数据
        return this.expressTableData
      } else if (this.searchForm.creationMethod == 2) {
        // 按照分拣箱生成的数据
        return this.expressTableDataByBox
      }
      return []
    }
  },
  data() {
    return {
      url: this.GLOBAL.domain + 'Sellshippingbirld/index',
      dialogVisible: false, // 控制弹窗显示状态
      changAddressDialog: false,
      ids: '',
      tableData: [],
      courierCompanyList: [],
      expressSelection: [],
      expressTableData: [],
      expressTableDataByBox: [],
      searchForm: {
        selectedCourier: '',
        creationMethod: '',
        generate_waybill_num: 1
      },
      form: {
        id: '',
        truename: '',
        phone: '',
        address: '',
        province_id: '',
        province: '',
        city_id: '',
        city: '',
        county_id: '',
        county: '',
      },
      provinceList: [],
      cityList: [],
      countyList: [],
      rules: {
        truename: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        province_id: [
          { required: true, message: '请选择省份', trigger: 'change' }
        ],
        city_id: [
          { required: true, message: '请选择城市', trigger: 'change' }
        ],
        county_id: [
          { required: true, message: '请选择区/县', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      regionOptions: [
        // 这里填写省市区的数据，可以使用静态数据或通过 API 获取
      ],
      addressText: '',
      createLoading: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      this.dialogVisible = false
    },
    changeAddresss(row) {
      this.form.id = row.id
      this.changAddressDialog = true
    },
    fetchProvinces() {
      this.$axios({
        url: this.GLOBAL.domain + 'JDgoods/index',
        method: 'POST',
        data: {
          act: 'getaddressinfos',
          type: 1 // 1省，2市，3区县
        }
      })
        .then(res => {
          if (res.Result == 0) {
            this.provinceList = res.Data
          }
        })
    },
    changeprovince(provinceId) {
      this.form.city_id = ''; // 清空城市选择
      this.form.county_id = ''; // 清空区县选择
      this.cityList = []; // 清空城市列表
      this.countyList = []; // 清空区县列表
      if (provinceId) {
        this.$axios({
          url: this.GLOBAL.domain + 'JDgoods/index',
          method: 'POST',
          data: {
            act: 'getaddressinfos',
            type: 2, // 2市
            id: provinceId
          }
        })
          .then(res => {
            if (res.Result == 0) {
              this.cityList = res.Data;
            }
          })
      }
    },
    changeCity(cityId) {
      this.form.county_id = ''; // 清空区县选择
      this.countyList = []; // 清空区县列表
      if (cityId) {
        this.$axios({
          url: this.GLOBAL.domain + 'JDgoods/index',
          method: 'post',
          data: {
            act: 'getaddressinfos',
            type: 3, // 3区县
            id: cityId
          }
        })
          .then(res => {
            if (res.Result == 0) {
              this.countyList = res.Data;
              if (this.countyList.length == 1) {
                this.form.county_id = this.countyList[0].id
              }
            }
          })
      }
    },
    selectionLineChangeHandle(selection) {
      this.expressSelection = selection;
    },
    // 打印快递单
    printExpress() {
      // 如果this.expressSelection中所有数据的recycle_status都等于1，printDisabled为false，否则为true
      let printDisabled = !this.expressSelection.every(item => item.recycle_status == 1)

      if (this.expressSelection.length < 1 || printDisabled) {
        this.$message.warning('存在未获取快递面单数据，请先获取面单后再打印')
        return
      }

      // 检查是否有已打印的面单
      const hasPrinted = this.expressSelection.some(item => item.is_print == 1)
      if (hasPrinted) {
        return this.$confirm('您选择的快递面单已经打印过，确定重新打印吗?', '提示', {
          confirmButtonText: '打印',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this._doPrint()
        }).catch(() => {
          this.$message.info('已取消打印')
        })
      }

      this._doPrint()
    },

    _doPrint() {
      // 必填数据 ！！！！
      let key = ''; // 快递鸟 API Key
      let id = ''; // 快递鸟用户id
      const isPreview = '1'; // 是否预览，0-不预览 1-预览


      // 获取expressRef表单中已选中的表单数据
      let requestData = []
      this.expressSelection.forEach(element => {
        if (!key) {
          key = element.kdniao_secret_key
          id = element.kdniao_app_id
        }
        const object = {
          OrderCode: element.order_code,
          PortName: ""
        }
        requestData.push(object)
      });

      requestData = JSON.stringify(requestData)

      // MD5加密
      const md5str = md5(requestData + key).toLowerCase();
      // base64
      const dataSign = Base64.encode(md5str);

      // 创建一个隐藏的表单
      const form = document.createElement('form');
      form.action = 'http://www.kdniao.com/External/PrintOrder.aspx'; // 快递鸟打印地址
      form.target = '_blank';
      form.method = 'POST';

      // 添加表单字段
      const requestDataInput = document.createElement('input');
      requestDataInput.type = 'hidden';
      requestDataInput.name = 'RequestData';
      requestDataInput.value = requestData;
      form.appendChild(requestDataInput);

      const dataSignInput = document.createElement('input');
      dataSignInput.type = 'hidden';
      dataSignInput.name = 'DataSign';
      dataSignInput.value = dataSign;
      form.appendChild(dataSignInput);

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'EBusinessID';
      idInput.value = id;
      form.appendChild(idInput);

      const isPreviewInput = document.createElement('input');
      isPreviewInput.type = 'hidden';
      isPreviewInput.name = 'IsPreview';
      isPreviewInput.value = isPreview;
      form.appendChild(isPreviewInput);

      // 将表单添加到 body 并提交
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      // 打印状态回调，通知后端已打印
      const printIds = this.expressSelection.map(item => item.id)
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'print_callback',
          id: printIds.join(',')
        }
      })
        .then(res => {
          this.getExpressList()
        });
    },
    openDialog(listData) {
      this.dialogVisible = true; // 打开弹窗
      this.historyDataList = listData
      this.getList(listData)
      this.getCourierCompanyList()
      this.getExpressList()
      this.fetchProvinces()
    },
    /**
     * 请求地址数据
     * @param listData 选中的订单列表 
     */
    getList(listData) {
      const ids = listData.map(item => item.id);
      // 记录销售单ID
      this.ids = ids.join(',')
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'electronic_waybill_details',
          id: this.ids
        }
      })
        .then(res => {
          this.tableData = [res.Data]
        })
    },
    /**
     * 获取快递下拉列表
     */
    getCourierCompanyList() {
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'choose_express_delivery'
        }
      })
        .then(res => {
          this.courierCompanyList = res.Data
        })
    },
    /**
     * 获取电子面单列表
     */
    getExpressList() {
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'get_generate_waybill',
          id: this.ids
        }
      })
        .then(res => {
          if (this.searchForm.creationMethod == 1) {
            // 整托生成的数据
            this.expressTableData = res.Data
          } else if (this.searchForm.creationMethod == 2) {
            // 按照分拣箱生成的数据
            this.expressTableDataByBox = res.Data
          }

        })
    },
    handleClose(done) {
      this.$emit('close');
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //   })
      //   .catch(_ => { });
    },
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('复制成功');
    },
    generateExpress() {
      this.createLoading = true
      // 这里添加生成电子面单的逻辑
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'generate_waybill',
          type: this.searchForm.creationMethod,  // 创建方式 creationMethod
          express_id: this.searchForm.selectedCourier, // 快递公司id
          generate_waybill_num: this.searchForm.generate_waybill_num,
          id: this.ids // 销售单id，多个时逗号隔开
        }
      })
        .then(res => {
          if (res.Result == 0) {
            this.getExpressList()
            if (this.searchForm.creationMethod == 1) {
              // 整托生成的数据
              this.expressTableDataByBox = []
            } else if (this.searchForm.creationMethod == 2) {
              // 按照分拣箱生成的数据
              this.expressTableData = []
            }
          }
        })
        .finally(() => {
          this.createLoading = false
        })
    },
    getExpress(row) {
      // 这里添加获取面单的逻辑
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'place_order_waybill',
          id: row.id
        }
      })
        .then(res => {
          if (res) {
            this.getExpressList()
            this.$message.success('获取面单成功!');
          }
        })
    },
    // 批量获取面单
    getExpressBacth() {
      const datas = this.expressSelection.map(item => item.id)
      this.$axios({
        url: this.GLOBAL.domain + 'Sellshippingbirld/index',
        method: 'POST',
        data: {
          act: 'batch_place_order_waybill',
          ids: datas.join(',')
        }
      })
        .then(res => {
          this.getExpressList()
          this.$message.success('获取面单成功!');

        })

    },
    recycleExpress(row) {
      // 添加确认提示
      this.$confirm('是否回收该快递单号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击确定后执行回收逻辑
        this.$axios({
          url: this.url,
          method: 'POST',
          data: {
            act: 'cancel_the_waybill',
            id: row.id
          }
        })
          .then(res => {
            this.getExpressList();
            this.$message.success('回收面单成功!');
          })
          .catch(error => {
            this.$message.error('回收面单失败!');
          });
      }).catch(() => {
        // 用户点击取消后执行的操作
        this.$message.info('已取消回收操作');
      });
    },
    parseAddress() {
      // 解析地址的逻辑
      this.$axios({
        url: this.url,
        method: 'post',
        data: {
          act: 'identify_adress',
          address: this.addressText
        }
      })
        .then(res => {
          this.form.phone = res.Data.phone
          this.form.truename = res.Data.truename
          if (res.Result == 0) {
            this.form.province_id = res.Data.province_id
            this.$axios({
              url: this.GLOBAL.domain + 'JDgoods/index',
              method: 'post',
              data: {
                act: 'getaddressinfos',
                type: 2,
                id: res.Data.province_id
              }
            })
              .then(Pres => {
                if (Pres.Result == 0) {
                  this.cityList = Pres.Data;
                  this.form.city_id = res.Data.city_id
                  this.$axios({
                    url: this.GLOBAL.domain + 'JDgoods/index',
                    method: 'post',
                    data: {
                      act: 'getaddressinfos',
                      type: 3,
                      id: res.Data.city_id
                    }
                  })
                    .then(Cres => {
                      if (Cres.Result == 0) {
                        this.countyList = Cres.Data;
                        if (!res.Data.county_id) {
                          this.form.county_id = Cres.Data[0].id
                        } else {
                          this.form.county_id = res.Data.county_id
                        }
                        this.form.address = res.Data.address
                      }
                    })
                }
              })
          }
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 根据province_id、city_id、county_id获取省市区名称
          this.form.province = this.provinceList.find(item => item.id === this.form.province_id).name
          this.form.city = this.cityList.find(item => item.id === this.form.city_id).name
          this.form.county = this.countyList.find(item => item.id === this.form.county_id).name

          this.$axios({
            url: this.GLOBAL.domain + 'Sellshippingbirld/index',
            method: 'post',
            data: {
              act: 'update_adress',
              ...this.form
            }
          })
            .then(res => {

              if (res.Result == 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.$refs.changeAddRef.resetFields()
                this.changAddressDialog = false
                this.getList(this.historyDataList)
              }

            })
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.addressText = ''
    }
  },
};
</script>

<style scoped>
/* 样式可以根据需要添加 */
.demo-form-inline {
  margin-top: 20px;
}

.divider {
  margin: 0px 0 20px;
  border-top: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/home/print/printerExpress.vue